import '../../../App.css'

const AndarBaharA = () => {

    return (
        <>
            <div className='bg-[#fff] h-[300px] overflow-auto'>
                <div className="">
                    <div id="rulesList___BV_modal_body_" className="modal-body">
                        <div id="rulesBoxContainer">
                            <div>
                                <p>
                                    <img src='../rulesImg/ab-a.webp' />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}
export default AndarBaharA